var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.625 1.375L5.079 12.1545C4.97944 12.2976 4.8473 12.4149 4.69349 12.4969C4.53967 12.5789 4.36858 12.6231 4.1943 12.626C4.02003 12.6289 3.84756 12.5903 3.69112 12.5135C3.53468 12.4366 3.39874 12.3237 3.2945 12.184L1.375 9.625","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Check.defaultProps = {"viewBox":"0 0 14 14","fill":"none"};

module.exports = Check;

Check.default = Check;
